export var GroupsSortBy;
(function (GroupsSortBy) {
    /** Undefined sorting fields. */
    GroupsSortBy["UNKNOWN"] = "UNKNOWN";
    /** Default sorting (recent activity, title, and member count). */
    GroupsSortBy["DEFAULT"] = "DEFAULT";
    /** Sort by recent activity date. */
    GroupsSortBy["RECENT_ACTIVITY"] = "RECENT_ACTIVITY";
    /** Sort by title. */
    GroupsSortBy["TITLE"] = "TITLE";
    /** Sort by member count. */
    GroupsSortBy["MEMBER_COUNT"] = "MEMBER_COUNT";
})(GroupsSortBy || (GroupsSortBy = {}));
export var AuthorizedGroupCreators;
(function (AuthorizedGroupCreators) {
    /** Undefined authorized group creator. */
    AuthorizedGroupCreators["UNKNOWN_POLICY"] = "UNKNOWN_POLICY";
    /** Only Wix Groups Managers can create new groups. */
    AuthorizedGroupCreators["OWNER"] = "OWNER";
    /** All members are allowed to create new groups. */
    AuthorizedGroupCreators["MEMBERS"] = "MEMBERS";
    /** Only group Wix Groups Managers can create new groups, but members can suggest to create a group via **Group Requests**. */
    AuthorizedGroupCreators["MEMBERS_WITH_APPROVAL"] = "MEMBERS_WITH_APPROVAL";
})(AuthorizedGroupCreators || (AuthorizedGroupCreators = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map